export default __webpack_public_path__ + "static/media/pennybun3.0f840406.png";